import httpRequest from "services/httpRequest";

const prefix = "/api/auth";

export const onGetCreditBalance = async params => {
  const result = await httpRequest({
    url: "/api/auth/check-credit-balance",
    method: "GET",
    params: params,
  });
  return result;
};

export const onVerifyTwoFactorAuth = async params => {
  const result = await httpRequest({
    url: `${prefix}/verify-authen-code/${params.id}`,
    method: "POST",
    data: params,
    successMessage: "toast.verifyTwoFactorAuthSuccess",
  });
  return result;
};

export const onRequestQRCode = async params => {
  const result = await httpRequest({
    url: `${prefix}/request-qr-code/${params.id}`,
    method: "POST",
    data: { ...params },
    successMessage: "toast.requestQRCodeSuccess",
  });
  return result;
};

export const onRequestAuthCode = async params => {
  const result = await httpRequest({
    url: `${prefix}/request-authen-code/${params.id}`,
    method: "POST",
    data: { ...params },
    successMessage: "toast.requestTwoFactorAuthSuccess",
  });
  return result;
};

export const onResetPassword = async params => {
  const result = await httpRequest({
    url: `${prefix}/reset-password/${params.id}`,
    method: "PUT",
    data: { ...params },
    successMessage: "toast.resetPassword.200",
  });
  return result;
};

export const onAppleLogin = async params => {
  const result = await httpRequest({
    url: "/api/auth/apple",
    method: "POST",
    data: params,
  });
  return result;
};

export const onFacebookLogin = async params => {
  const result = await httpRequest({
    url: "/api/auth/facebook",
    method: "POST",
    data: params,
  });
  return result;
};

export const onGoogleLogin = async params => {
  const result = await httpRequest({
    url: "/api/auth/google",
    method: "POST",
    data: params,
  });
  return result;
};

export const onLogin = async params => {
  const result = await httpRequest({
    url: "/api/auth",
    method: "POST",
    data: params,
  });
  return result;
};

export const getAuthInfo = async () => {
  const result = await httpRequest({
    url: "/api/auth",
    method: "GET",
  });
  return result;
};

export const onVerifyEmail = async params => {
  const result = await httpRequest({
    url: "/api/auth/verified/email",
    method: "GET",
    params: params,
  });
  return result;
};

export const onLogout = async () => {
  const result = await httpRequest({
    url: "/api/auth",
    method: "DELETE",
  });
  return result;
};

export const onSignUp = async params => {
  const result = await httpRequest({
    url: "/api/auth/sign-up",
    method: "POST",
    data: params,
    successMessage: "toast.signup.200",
  });
  return result;
};

export const onForgotPassword = async params => {
  const result = await httpRequest({
    url: "/api/auth/forgot-password",
    method: "POST",
    data: params,
  });
  return result;
};
